export const languageInitialState = {
  languages: [],
  error: null,
};
